import { render, staticRenderFns } from "./ManagePlatformPostsModal.vue?vue&type=template&id=3d687060&scoped=true"
import script from "./ManagePlatformPostsModal.vue?vue&type=script&lang=ts"
export * from "./ManagePlatformPostsModal.vue?vue&type=script&lang=ts"
import style0 from "./ManagePlatformPostsModal.vue?vue&type=style&index=0&id=3d687060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d687060",
  null
  
)

export default component.exports